// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import {Dictionary} from '../../../shared/models/dictionary.model';
import {IBaseType} from '../../../shared/enums/ibase-type.enum';

export interface IFinanceDisbursementRequestType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class FinanceDisbursementRequestType implements IFinanceDisbursementRequestType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
        Returns CheckDisbursement FinanceDisbursementRequestType
	**/
    get CheckDisbursement(): IFinanceDisbursementRequestType {
        return this.FromId(1);
    }

    /**
    Returns CheckDisbursement FinanceDisbursementRequestType
**/
    get DigitalDisbursement(): IFinanceDisbursementRequestType {
        return this.FromId(2);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: '1', displayValue: 'Check Disbursement', description: 'Disbursement amount via check.', sortOrder: 1, active: true });
        this._dictionary.add('2', { id: 2, value: '2', displayValue: 'Digital Disbursement', description: 'Disbursement amount via electronic transfer.', sortOrder: 2, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IFinanceDisbursementRequestType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IFinanceDisbursementRequestType {
        var match = this._dictionary.getValues().filter(function(data) {
            return data.value == value;
        });

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IFinanceDisbursementRequestType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IFinanceDisbursementRequestType[] {
        return this.GetAll().filter(function(data) {
            return data.active;
        });
    }

    public Sort(primaryField, secondaryField, reverse): IFinanceDisbursementRequestType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = function(path, reverse, primer, then) {
        var get = function(obj, path) {
                if (path) {
                    path = path.split('.');
                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }
                    return obj[path[len]];
                }
                return obj;
            },
            prime = function(obj) {
                return primer ? primer(get(obj, path)) : get(obj, path);
            };

        return function(a, b) {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
